if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( productVariants && ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					customElements.whenDefined('product-page').then(() => {
						const productPage = this.quickViewModal.querySelector('product-page');
						if ( productPage && typeof productPage.onVariantChangeHandler === 'function' ) {
							productPage.onVariantChangeHandler({target:productVariants});
						}
					});
				}
			}

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const parsedDoc = new DOMParser().parseFromString(text, 'text/html');
							const quickViewHTML = parsedDoc.querySelector('#product-quick-view');

							// Some apps (e.g. the Simple Bundles & Kits bundle builder) render their
							// UI into a global app embed block, which Shopify inserts as a direct
							// child of <body> rather than inside #product-quick-view. Those wrapper
							// elements exist on every page (even empty, or holding only a <script>
							// config block) so their mere presence doesn't mean anything is missing.
							// Only treat it as a problem when the wrapper holds real markup we'd be
							// dropping - that's the case where the quick-view modal would let
							// shoppers add an incomplete product (e.g. a bundle with no items picked).
							const hasExternalAppEmbedUI = Array.from(parsedDoc.querySelectorAll('body > [id^="shopify-block-"]'))
								.filter(elm => !quickViewHTML.contains(elm))
								.some(elm => elm.querySelector('*:not(script):not(style):not(link)'));

							if ( hasExternalAppEmbedUI ) {
								window.location.href = target.getAttribute('href');
								return;
							}

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							// Scripts copied in via innerHTML never execute on their own.
							// External (src) page scripts only need to load once globally;
							// inline scripts are instance-specific (e.g. the selling-plan
							// picker's binding logic) and must re-run for every product.
							this.quickViewModal.querySelectorAll('script').forEach(elm=>{
								if ( elm.src ) {
									if ( window.productPageScripts ) return;
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
								} else {
									const script = document.createElement('script');
									script.textContent = elm.textContent;
									elm.replaceWith(script);
								}
							});
							window.productPageScripts = true;

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
								// Some product-detail apps (e.g. Seal Subscriptions) only render
								// their widgets on this event, rather than on page load, so they
								// can pick up content shown in a quick-view modal.
								window.dispatchEvent(new Event('product_modal_displayed'));
							}, 250);

						});

				} else {
					this.quickViewModal.show();
					window.dispatchEvent(new Event('product_modal_displayed'));
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}